// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundHint, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { backgroundColor } from "@microsoft/fast-components-styles-msft";
import { enums } from "../../utils/enums";
import { reset } from "../../utils/commonJssConstants";

export const PublisherProfilePageStyles = (config: DesignSystem) => ({
    publisherProfilePageContainer: {
        ...reset,
        display: "flex",
        "flex-direction": "row",
        "align-items": "flex-start",
        "justify-content": "stretch",
        "min-width": "360px",
        background: backgroundColor,

        "& .cwt-publisher-profile-tabs-container": {
            margin: "3px 27px 56px",
            flex: "1",
            "max-width": "960px"
        },

        /* RESPONSIVE CLASSES */
        ["&." + enums.responsiveLevels.L0]: {
            "flex-direction": "column",
            "align-items": "stretch",

            "& .cwt-publisher-profile-tabs-container": {
                margin: "9px 0 56px",
                width: "100%"
            }
        }
    },
    infoPopover: {
        "min-width": "190px",
        height: "75px",
        "box-sizing": "border-box",
        "text-align": "left",
        margin: "0",
        padding: "12px",
        "font-size": "13px",
        color: neutralForegroundHint,
        background: neutralLayerCard,
        "border-radius": "4px",
        "-webkit-box-shadow": "0px 12.8px 28.8px rgba(0, 0, 0, 0.13), 0px 0px 9.2px rgba(0, 0, 0, 0.11)",
        "-moz-box-shadow": "0px 12.8px 28.8px rgba(0, 0, 0, 0.13), 0px 0px 9.2px rgba(0, 0, 0, 0.11)",
        "box-shadow": "0px 12.8px 28.8px rgba(0, 0, 0, 0.13), 0px 0px 9.2px rgba(0, 0, 0, 0.11)"
    }
});
